var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comWrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"comItemWrap"},[_c('div',{staticClass:"comItemTiitle"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"comItemContent",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-23184c45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/solution/components/com1.vue
// module id = arQ9
// module chunks = 1